<ng-container *ngIf="open">
  <div class="slide-over-backdrop"
       (click)="requestClose()"
       aria-hidden="true">
  </div>

  <aside class="slide-over-panel"
         role="dialog"
         aria-modal="true"
         [attr.aria-label]="ariaLabelledBy ? null : title"
         [attr.aria-labelledby]="ariaLabelledBy || null"
         [style.width]="widthStyle">
    <header class="slide-over-header">
      <h2 class="slide-over-title">{{ title }}</h2>
      <button type="button"
              class="slide-over-close"
              (click)="requestClose()"
              aria-label="Cerrar">
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path fill="currentColor"
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </header>

    <div class="slide-over-body">
      <ng-content></ng-content>
    </div>
  </aside>
</ng-container>